import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FieldDisclaimer,
  FieldInput,
  FieldName,
  FormContainer,
  ModalTextFieldGroup
} from '../../Styles';

const RetailToolsRetailVdpModals = ({
  testId,
  customizationMetadata,
  dealerData,
  handleBlur,
  handleInputFieldChange,
  emailInputError,
  phoneInputError
}) => {
  const localHandleBlur = e => {
    handleBlur(e);
  };
  const localHandleInputFieldChange = e => {
    handleInputFieldChange(e);
  };
  return (
    <FormContainer variant="modal">
      <ModalTextFieldGroup
        key={customizationMetadata.salespersonName.displayName}
      >
        <FieldName>
          {customizationMetadata.salespersonName.displayName}
          <FieldInput
            id="salespersonName"
            data-testid={`${testId}-salespersonName`}
            variant="salespersonName"
            ref={customizationMetadata.salespersonName.ref}
            type={customizationMetadata.salespersonName.type}
            maxLength={customizationMetadata.salespersonName.limit}
            defaultValue={dealerData?.retailVdp?.salespersonName}
            placeholder={customizationMetadata.salespersonName.placeholder}
            onChange={localHandleInputFieldChange}
          />
        </FieldName>
      </ModalTextFieldGroup>
      <ModalTextFieldGroup
        key={customizationMetadata.salespersonEmail.displayName}
      >
        <FieldName>
          {customizationMetadata.salespersonEmail.displayName}
          <FieldInput
            id="salespersonEmail"
            data-testid={`${testId}-salespersonEmail`}
            variant="salespersonEmail"
            isEmailInputError={emailInputError}
            ref={customizationMetadata.salespersonEmail.ref}
            type={customizationMetadata.salespersonEmail.type}
            maxLength={customizationMetadata.salespersonEmail.limit}
            defaultValue={dealerData?.retailVdp?.salespersonEmail}
            placeholder={customizationMetadata.salespersonEmail.placeholder}
            onBlur={localHandleBlur}
            onChange={localHandleInputFieldChange}
          />
        </FieldName>
      </ModalTextFieldGroup>
      <ModalTextFieldGroup
        key={customizationMetadata.salespersonPhone.displayName}
      >
        <FieldName>
          {customizationMetadata.salespersonPhone.displayName}
          <FieldInput
            id="salespersonPhone"
            data-testid={`${testId}-salespersonPhone`}
            variant="salespersonPhone"
            isPhoneInputError={phoneInputError}
            ref={customizationMetadata.salespersonPhone.ref}
            type={customizationMetadata.salespersonPhone.type}
            maxLength={customizationMetadata.salespersonPhone.limit}
            defaultValue={dealerData?.retailVdp?.salespersonPhone}
            placeholder={customizationMetadata.salespersonPhone.placeholder}
            onBlur={localHandleBlur}
            onChange={localHandleInputFieldChange}
          />
        </FieldName>
      </ModalTextFieldGroup>
      <ModalTextFieldGroup
        key={customizationMetadata.dealershipWebsite.displayName}
      >
        <FieldName>
          {customizationMetadata.dealershipWebsite.displayName}
          <>
            <FieldInput
              id="dealershipWebsite"
              data-testid={`${testId}-dealershipWebsite`}
              variant="dealershipWebsite"
              ref={customizationMetadata.dealershipWebsite.ref}
              type={customizationMetadata.dealershipWebsite.type}
              maxLength={customizationMetadata.dealershipWebsite.limit}
              defaultValue={dealerData?.retailVdp?.dealershipWebsite}
              placeholder={customizationMetadata.dealershipWebsite.placeholder}
              onChange={localHandleInputFieldChange}
            />
            <FieldDisclaimer
              data-testid={`${testId}-linkToUsedDisclaimerModal`}
            >
              <FormattedMessage id="retail.tools.setting.retailVdp.inventory.disclaimer" />
            </FieldDisclaimer>
          </>
        </FieldName>
      </ModalTextFieldGroup>
    </FormContainer>
  );
};

export default RetailToolsRetailVdpModals;
